const MIN_QUERY_LENGTH = 3; // atlas answers 400 below this
const REQUEST_TIMEOUT_MS = 10000;

function url(path, params) {
  const query = new URLSearchParams(Object.assign({ format: 'google' }, params));

  return `${window.QB.atlas.host}${path}?${query}`;
}

function failure(message, status) {
  const error = new Error(message);
  error.status = status;

  return error;
}

// AbortController não cobre os targets do babel (chrome 58, safari 11) e o core-js não
// polyfilla DOM, então o teto de espera é uma corrida, como fazia o loader do SDK antigo.
async function get(path, params) {
  let timer;
  const timeout = new Promise((resolve, reject) => {
    timer = setTimeout(() => reject(failure(`Atlas request timed out: ${path}`, 'TIMEOUT')), REQUEST_TIMEOUT_MS);
  });

  try {
    // fetch só rejeita em falha de rede, DNS e CORS — normaliza pra todo erro ter status.
    const response = await Promise.race([fetch(url(path, params)), timeout])
      .catch((error) => {
        throw error.status ? error : failure(`Atlas request failed: ${path}`, 'NETWORK_ERROR');
      });

    if (!response.ok) {
      throw failure(`Atlas request failed: ${path}`, response.status);
    }

    return response.json();
  } finally {
    clearTimeout(timer);
  }
}

function hasCoordinates(result) {
  const location = (result && result.geometry && result.geometry.location) || {};

  return typeof location.lat === 'number' && typeof location.lng === 'number';
}

class AtlasApiService {
  async geocode(lat, lng) {
    const data = await get(`/geocoding/${lat}/${lng}`);

    if (data && data.status === 'OK' && Array.isArray(data.results) && data.results.length) {
      return data.results;
    }

    throw failure('Geocode failed', (data && data.status) || 'ERROR');
  }

  async getPlacePredictions(input) {
    const query = (input || '').trim();

    if (query.length < MIN_QUERY_LENGTH) {
      return [];
    }

    // `?format=google` on autocomplete returns the bare array, with no `{ status }` envelope.
    const data = await get('/autocomplete', { q: query });

    if (Array.isArray(data)) {
      return data;
    }

    throw failure('Place predictions failed', 'ERROR');
  }

  async geocodeFromPlace(placeId) {
    const data = await get(`/places/${encodeURIComponent(placeId)}`);

    if (data && data.status === 'OK' && hasCoordinates(data.result)) {
      return data.result;
    }

    throw failure('Geocode place failed', (data && data.status) || 'ZERO_RESULTS');
  }
}

export default new AtlasApiService();
